import React from "react";
import { Link } from "react-router-dom";

interface SortableHeaderProps {
  title: React.ReactNode;
  field: string;
  currentSort: string;
  currentOrder: "asc" | "desc";
  onSort: (field: string, order: "asc" | "desc") => void;
  className?: string;
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  title,
  field,
  currentSort,
  currentOrder,
  onSort,
  className = "",
}) => {
  const isActive = currentSort === field;

  const handleSort = (order: "asc" | "desc") => {
    onSort(field, order);
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-between ${className}`}
    >
      <span>{title}</span>
      <div className="d-flex flex-column ms-2">
        <Link
          to="#"
          className={`sort-btn ${
            isActive && currentOrder === "asc" ? "active" : ""
          }`}
          onClick={(e) => {
            e.preventDefault();
            handleSort("asc");
          }}
          style={{
            fontSize: "10px",
            lineHeight: "1",
            color: isActive && currentOrder === "asc" ? "#007bff" : "#6c757d",
            textDecoration: "none",
          }}
        >
          <i className="ti ti-chevron-up" />
        </Link>
        <Link
          to="#"
          className={`sort-btn ${
            isActive && currentOrder === "desc" ? "active" : ""
          }`}
          onClick={(e) => {
            e.preventDefault();
            handleSort("desc");
          }}
          style={{
            fontSize: "10px",
            lineHeight: "1",
            color: isActive && currentOrder === "desc" ? "#007bff" : "#6c757d",
            textDecoration: "none",
            marginTop: "-2px",
          }}
        >
          <i className="ti ti-chevron-down" />
        </Link>
      </div>
    </div>
  );
};

export default SortableHeader;
